export const SHOPPING_CART_PAYMENT_MAKE_FAILED_RECEIVED_RESPONSE =
    'SHOPPING_CART_PAYMENT_MAKE_FAILED_RECEIVED_RESPONSE';
export const SHOPPING_CART_PAYMENT_MAKE_VALIDATION_EXCEPTION =
    'SHOPPING_CART_PAYMENT_MAKE_VALIDATION_EXCEPTION';
export const SHOPPING_CART_PAYMENT_MAKE_SUCCESS =
    'SHOPPING_CART_PAYMENT_MAKE_SUCCESS';
